import { Stack, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PencilSimple } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

import { Button, Section, Spacer } from 'theSource/components';
import { FormFieldsCategory } from 'theSource/types';
import { getReadonlyField } from 'theSource/utils';

interface FamilyMemberDetailsProps {
  categories: FormFieldsCategory[];
}

export const FamilyMemberDetails = ({
  categories,
}: FamilyMemberDetailsProps) => {
  const { t } = useTranslation('common');
  const theme = useTheme();
  const navigate = useNavigate();

  const handleEditClick = () => navigate('edit');

  return (
    <>
      <Button
        data-testid="edit-button"
        label={t('editInfoButtonLabel')}
        startIcon={<PencilSimple weight="bold" />}
        variant="secondary"
        onClick={handleEditClick}
      />
      <Spacer height={9} />
      <Stack spacing={theme.spacing(8)}>
        {categories.map((category: FormFieldsCategory) => (
          <Section key={category.name} name={category.name}>
            {category.fields.map(getReadonlyField)}
          </Section>
        ))}
      </Stack>
    </>
  );
};
